export default function rlxCollapseWatchPage() {
    const triggers = document.querySelectorAll('.js--rlx-collapse-trigger');
    const triggerAppointmentSelector = 'js--rlx-collapse-trigger-appointment';
    const triggerContactSelector = 'js--rlx-collapse-trigger-contact';
    const triggerAppointment = document.querySelector(`.${triggerAppointmentSelector}`);
    const triggerContact = document.querySelector(`.${triggerContactSelector}`);
    const contactContainer = document.getElementById('model-contact');
    if (triggerAppointment === null || triggerContact === null) return;
    let isTriggering = false;
    const scrollToContactContainer = (trigger) => {
        setTimeout(() => {
            if (trigger.classList.contains('is--active')) {
                window.scrollTo({
                    top: contactContainer.offsetTop + 90,
                    behavior: 'smooth',
                });
            }
        }, 270);
    };

    /* Used click functionality instead of changing classes to display/hide elements,
        to keep a11y features like aria-expanded.
        Function from click on panel self comes from swCollapsePanel Plugin, this is
        only counterpart for the 2nd panel */
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            if (isTriggering) return;
            isTriggering = true;

            if (trigger.classList.contains(triggerContactSelector)) {
                triggerAppointment.click();
            } else {
                triggerContact.click();
                scrollToContactContainer(trigger);
            }
            isTriggering = false;
        });
    });
}
